// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3CT1Q","label":"SetPasswdForm_label__3zIKZ"};